<template>
  <div class="ah-card-push">
    <AhPicture
      v-if="cardContent.src"
      :src="cardContent.src"
      :alt="cardContent.alt"
      :is-media-pic="$imgFromDynamicMedia"
      :pictures-media="picturesMediaData"
    />
    <div class="ah-card-push__content">
      <p
        v-if="cardContent.title"
        class="ah-card-push__content-title"
      >
        <strong>
          {{ cardContent.title }}
        </strong>
      </p>
      <!-- eslint-disable vue/no-v-html -->
      <p
        v-if="cardContent.desc"
        class="ah-card-push__content-desc"
        v-html="cardContent.desc"
      />
      <AhLink
        v-if="cardContent.buttonText"
        :id="cardContent.id"
        class="ah-link-button--action ah-link-button"
        :url="cardContent.url"
        :tracking="cardContent.tracking"
        @ah-link-clicked="clickPush"
      >
        {{ cardContent.buttonText }}
      </AhLink>
    </div>
  </div>
</template>

<script>
  import AhLink from '../../atoms/AhLink/AhLink.vue';
  import AhPicture from '../../atoms/AhPicture/AhPicture.vue';
  export default {
    name: 'AhCardPush',
    components: {
      AhLink,
      AhPicture
    },
    inject: {
      $imgFromDynamicMedia: {
        default: false,
      },
      $dynamicMediaParams: {
        default: false,
      }
    },
    props : {
      cardContent: {
        type : Object,
        required: true,
        /* validator: propValue => {
          return (propValue.src && propValue.alt && propValue.title && propValue.desc && propValue.url && propValue.buttonText );
        } */
      }
    },
    computed: {
      picturesMediaData() {
        return this.$dynamicMediaParams ? Object.values(this.$dynamicMediaParams['push']) : null;
      }
    },
    methods: {
      clickPush (data) {
        this.$emit('clickPush', {tracking:'', ...this.cardContent, ...data});
      }
    }
  };
</script>
